import { Gap, Icon } from '@common/components';
import { Button, Select } from 'antd';
import React from 'react';

export type FileViewerFileType = {
  id: string;
  url?: string | null;
  name?: string;
  uploadedAt?: string;
  contentType?: string;
};

type FileSelectorProps = {
  sourceFiles: FileViewerFileType[];
  selectedFile: FileViewerFileType | undefined;
  onChange: (fileId: string) => void;
};

export function FileSelector({
  sourceFiles,
  selectedFile,
  onChange,
}: FileSelectorProps) {
  return (
    <Gap>
      <Select
        size="large"
        data-testid="file-select-input"
        style={{ width: '100%' }}
        placeholder="Select a pdf file..."
        value={selectedFile?.id}
        onChange={onChange}
      >
        {sourceFiles.map(({ id, url, name }) => {
          return (
            <Select.Option key={url} value={id} title={name}>
              {name}
            </Select.Option>
          );
        })}
      </Select>
      <a data-testid="download-link" href={selectedFile?.url || undefined}>
        <Button type="link" size="large">
          <Gap align="center">
            <Icon icon="download" kind="regular" />
            <span>Download</span>
          </Gap>
        </Button>
      </a>
    </Gap>
  );
}
